<template>
    <div ref="fullscreenContainer" style="background-color: #eceff1;">
        <v-container fluid>
            <v-dialog v-model="showFullscreenPrompt" persistent max-width="400">
                <v-card>
                    <v-card-title class="justify-center text-h5">Modo fullscreen necessário</v-card-title>
                    <v-card-text class="text-center">
                        Para uma melhor experiência, clique no botão abaixo para ativar o modo de tela cheia.
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn color="primary" @click="ativarFullscreen" large block>Ativar Fullscreen</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


            <v-col v-if="loading">
                <v-row class="justify-center mb-4">
                    <v-img
                        style="margin: auto;"
                        aspect-ratio="3"
                        max-width="180px"
                        src="../assets/sesi-logo.png"
                    ></v-img>
                </v-row>
                <v-row class="justify-center mb-4">
                    <v-progress-circular
                        indeterminate
                        color="primary"
                        size="70"
                    ></v-progress-circular>
                </v-row>
            </v-col>

            <div v-else>
                <v-row class="justify-center mb-4">
                    <v-img
                        style="margin: auto;"
                        aspect-ratio="3"
                        max-width="180px"
                        src="../assets/sesi-logo.png"
                    ></v-img>
                </v-row>

                <v-row class="justify-center mb-4">
                    <h3 class="text-center primary--text font-weight-bold blue--text">
                        {{ unidadeSelecionada }}
                    </h3>
                </v-row>

                <v-stepper v-model="step" class="mb-4">
                    <v-stepper-header>
                        <v-stepper-step :complete="step > 1" step="1">
                            Selecione o tipo de atendimento
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 2" step="2">
                            Escolha o tipo de cliente
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="step > 3" step="3">
                            Informe a prioridade
                        </v-stepper-step>
                    </v-stepper-header>
                </v-stepper>

                <v-card class="pa-5 mx-auto full-width" outlined>
                    <div v-if="step === 1">
                        <v-row class="justify-center">
                            <v-col cols="12" md="6" v-for="tipo in tiposAtendimento" :key="tipo.IdTipoAtendimento">
                                <v-btn
                                    color="primary"
                                    class="mx-2 my-4"
                                    large
                                    height="80px"
                                    elevation="5"
                                    block
                                    @click="selecionarTipoAtendimento(tipo)"
                                >
                                    {{ tipo.TipoAtendimento }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>

                    <div v-if="step === 2">
                        <v-row class="justify-center">
                            <v-col cols="12" md="6" class="d-flex flex-column align-center">
                                <v-btn
                                    v-for="tipoCliente in tiposCliente"
                                    :key="tipoCliente.IdTipoCliente"
                                    color="blue darken-2"
                                    class="mx-2 my-4"
                                    large
                                    height="80px"
                                    elevation="5"
                                    block
                                    @click="selecionarTipoCliente(tipoCliente)"
                                >
                                    {{ tipoCliente.TipoCliente }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="justify-start">
                            <v-col cols="auto">
                                <v-btn
                                    icon
                                    small
                                    @click="voltarStep"
                                    color="blue darken-2"
                                    class="ml-2"
                                    style="height: 80px; width: 80px;"
                                >
                                    <v-icon size="64">mdi-arrow-left</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    
                    <div v-if="step === 3">
                        <v-row class="justify-center">
                            <v-col cols="12" md="4" class="d-flex flex-column align-center">
                                <v-btn
                                    v-for="prioridade in prioridades"
                                    :key="prioridade.IdPrioridade"
                                    :color="prioridade.IdPrioridade === 1 ? 'blue darken-2' : 'red darken-2'"
                                    class="mx-2 my-4"
                                    large
                                    height="80px"
                                    elevation="5"
                                    outlined
                                    block
                                    @click="selecionarPrioridade(prioridade)"
                                >
                                    {{ prioridade.Prioridade }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="justify-start">
                            <v-col cols="auto">
                                <v-btn
                                    icon
                                    small
                                    @click="voltarStep"
                                    color="blue darken-2"
                                    class="ml-2"
                                    style="height: 80px; width: 80px;"
                                >
                                    <v-icon size="64">mdi-arrow-left</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>                    
                </v-card>
                <p class="text-center welcome-text mt-4">Seja bem-vindo, retire sua senha e aguarde!</p>                
            </div>
        </v-container>
        <AlertSystem :snackbar="system.snackbar"></AlertSystem>
    </div>
</template>

<script>
import axios from "axios";
import AlertSystem from "../components/AlertSystem";

export default {
    components:{
        AlertSystem,
    },
    data() {
        return {
            step: 1,
            loading: true,
            unidadeSelecionada: this.$route.query.Unidade || "Unidade Não Informada",
            IdUnidade: this.$route.query.IdUnidade,
            tipoSelecionado: null,
            tipoClienteSelecionado: null,
            prioridadeSelecionada: null,
            tiposAtendimento: [],
            tiposCliente: [],
            prioridades: [],
            system: {
                snackbar: {},
            },
            showFullscreenPrompt: false,
        };
    },
    methods: {
        async fetchData() {
            try {
                const [atendimentoRes, clienteRes, prioridadeRes] = await Promise.all([
                    axios.get(`/senharecepcao/tipoatendimento/${this.IdUnidade}`),
                    axios.get("/senharecepcao/tipocliente"),
                    axios.get("/senharecepcao/prioridade"),
                ]);
                this.tiposAtendimento = atendimentoRes.data;
                this.tiposCliente = clienteRes.data;
                this.prioridades = prioridadeRes.data;
            } catch (error) {                
                this.snackbar.message = "Erro ao carregar os dados iniciais. Tente novamente.";
                this.snackbar.visible = true;
            } finally {
                this.loading = false;
            }
        },
        voltarStep() {
            if (this.step > 1) {
                this.step -= 1;
            }
        },
        verificarFullscreen() {
            const isFullscreen =
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement;
            this.showFullscreenPrompt = !isFullscreen; 
        },
        ativarFullscreen() {
            const element = this.$refs.fullscreenContainer;
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        },
        selecionarTipoAtendimento(tipo) {
            this.tipoSelecionado = tipo;
            this.step = 2;
        },
        selecionarTipoCliente(tipoCliente) {
            this.tipoClienteSelecionado = tipoCliente;
            this.step = 3;
        },
        selecionarPrioridade(prioridade) {
            this.prioridadeSelecionada = prioridade;
            this.gerarSenha();
        },
        async gerarSenha() {
            const payload = {
                intTipoCliente: this.tipoClienteSelecionado.IdTipoCliente,
                intPrioridade: this.prioridadeSelecionada.IdPrioridade,
                intTipoAtendimento: this.tipoSelecionado.IdTipoAtendimento,
                intUnidade: parseInt(this.IdUnidade),
            };

            try {
                const response = await axios.post("/senharecepcao/gerarsenha", payload);                
                this.gerarpdf(response.data.RetornoIdSenha)                
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Senha gerada com sucesso!',
                    color: "green",
                };
            } catch (error) {
                this.system.snackbar = {
                    snackbar: true,
                    text: 'Erro ao gerar a sucesso.',
                    color: "red",
                };
            } finally {
                this.resetEtapas(); 
                this.snackbar.visible = true;
            }
        },
        gerarpdf(idSenha) {
            this.axios.get(`/senharecepcao/senha/${idSenha}/imprimir`, { responseType: "blob" }).then((res) => {
                const pdfBlob = new Blob([res.data], { type: "application/pdf" });
                const pdfUrl = URL.createObjectURL(pdfBlob);
                const iframe = document.createElement("iframe");
                
                iframe.style.display = "none";
                iframe.src = pdfUrl;
                
                document.body.appendChild(iframe);
                
                iframe.onload = () => {
                    iframe.contentWindow.print();
                };
            });
        },
        resetEtapas() {
            this.step = 1;
            this.tipoSelecionado = null;
            this.tipoClienteSelecionado = null;
            this.prioridadeSelecionada = null;
        },
    },
    mounted() {
        this.fetchData();
        this.ativarFullscreen();
        this.verificarFullscreen();
        document.addEventListener("fullscreenchange", this.verificarFullscreen);
    },
    beforeDestroy() {
        document.removeEventListener("fullscreenchange", this.verificarFullscreen);
    },
};
</script>

<style scoped>
.full-width {
    width: 100%;
    max-width: 100%;
}

.main-title {
    font-weight: bold;
    color: #444;
}

.category-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
}

.v-btn {
    width: 100%;
    height: 80px;
    max-width: 350px;
    border-radius: 10px;
    font-weight: bold;
    font-size: 20px;
    color: white;
}

.welcome-text {
    font-size: 0.8rem;
    color: #555;
}

.blue--text {
    color: #1976d2 !important;
    font-weight: bold;
}


.v-card {
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.v-card-actions {
    justify-content: center;
}
</style>
